export default "__VITE_ASSET__a7398134__"